import React from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../Shared/ErrorPopUp'
import { AsyncCategorySelect } from '../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../Shared/AsyncBrandSelect'
import AsyncProductSelect from '../Shared/AsyncProductSelect'
import NumberFormat from 'react-number-format'
import measurementTypes from '../../_constants/measurementTypes'
import MeasurementTypeSelect from '../Shared/MeasurementTypeSelect'

export default ({
  touched,
  errors,
  setFieldValue,
  values,
  handleBlur,
  categoryType,
  initialRelatedProducts,
  onChangeIsGraseTwo,
  isGradeTwo
}) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="row">
        <div className="form-inline">
          <div className="col-md-12">
            <label>نام کالا</label>
            <Field
              type="text"
              value={values.name}
              onBlur={handleBlur}
              name="name"
              autoFocus
              className={
                getIn(touched, 'name')
                  ? getIn(errors, 'name')
                    ? 'text-input has-error'
                    : 'text-input'
                  : 'text-input has-error'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="name" />
          </div>

          <div className="col-md-3">
            <label>دسته بندی</label>
            <AsyncCategorySelect
              categoryType={categoryType}
              defaultValue={values.categoryId}
              name="categoryId"
              onChange={(val, measurementType) => {
                // console.log(val);

                if (
                  val === '2f04bd46-c365-4320-3bcf-08d7cb2bcfeb' ||
                  val === 'c8374e6c-8809-46b6-d2b6-08d7cb2e9469'
                ) {
                  onChangeIsGraseTwo(1)
                  var rp = values.relatedProducts
                  rp = rp.filter(el => el.index !== 4)
                  setFieldValue('relatedProducts', rp)
                } else {
                  onChangeIsGraseTwo(0)
                }

                setFieldValue('categoryId', val)
                setFieldValue('measurementType', measurementType)
              }}
              className={
                getIn(touched, 'categoryId')
                  ? getIn(errors, 'categoryId')
                    ? 'semantic-select-box has-error'
                    : 'semantic-select-box'
                  : 'semantic-select-box has-error'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="categoryId" />
          </div>

          <div className="col-md-3">
            <label>برند</label>
            <AsyncBrandSelect
              brandType={categoryType === 0 ? 0 : 1}
              defaultValue={values.brandId}
              name="brandId"
              onChange={val => {
                // console.log(val);

                setFieldValue('brandId', val)
              }}
              className={
                getIn(touched, 'brandId')
                  ? getIn(errors, 'brandId')
                    ? 'semantic-select-box has-error'
                    : 'semantic-select-box'
                  : 'semantic-select-box has-error'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="brandId" />
          </div>

          {/* <div className="col-md-4">
            <label>موجودی {values.measurementType !== undefined ? '(' + measurementTypes.filter(el => el.value === values.measurementType)[0].label + ')' : ''}</label>
            <NumberFormat isNumericString allowNegative={false}
              disabled={values.measurementType === undefined}
              defaultValue={values.quantity}
              value={values.quantity}
              name="quantity"
              onChange={(e) => {
                setFieldValue('quantity', e.target.value)
              }}
              onBlur={handleBlur}
              className={getIn(touched, "quantity") ? getIn(errors, "quantity") ? "text-input has-error" : "text-input" : "text-input has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="quantity" />
          </div> */}

          {/* <div className="clearfix"></div> */}

          <div className="col-md-3">
            <label>کد کالا در نرم افزار حسابداری</label>
            <NumberFormat
              isNumericString
              allowNegative={false}
              defaultValue={values.extraCode}
              value={values.extraCode}
              name="extraCode"
              onChange={e => {
                setFieldValue('extraCode', e.target.value)
              }}
              onBlur={handleBlur}
              className={
                getIn(touched, 'extraCode')
                  ? getIn(errors, 'extraCode')
                    ? 'text-input has-error'
                    : 'text-input'
                  : 'text-input has-error'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="extraCode" />
          </div>

          <div className="col-md-3">
            <label>کد کوتاه کالا</label>
            <NumberFormat
              isNumericString
              allowNegative={false}
              defaultValue={values.shortExtraCode}
              value={values.shortExtraCode}
              name="shortExtraCode"
              onChange={e => {
                setFieldValue('shortExtraCode', e.target.value)
              }}
              onBlur={handleBlur}
              className="text-input"
            />
            <ErrorMessage component={ErrorPopUp} name="shortExtraCode" />
          </div>

          <div className="clearfix" />

          <div className="col-md-3 col-sm-4">
            <label>واحد اندازه گیری اصلی</label>
            <MeasurementTypeSelect
              defaultValue={values.measurementType}
              onChange={val => {
                setFieldValue('measurementType', val)
              }}
              className={
                getIn(errors, 'measurementType') &&
                getIn(touched, 'measurementType')
                  ? 'text-input has-error rtl'
                  : 'text-input required rtl'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="measurementType" />
          </div>

          <div className="col-md-3 col-sm-4">
            <label>واحد اندازه گیری فرعی</label>
            <MeasurementTypeSelect
              defaultValue={values.subMeasurementType}
              onChange={val => {
                setFieldValue('subMeasurementType', val)
              }}
              className={
                getIn(errors, 'subMeasurementType') &&
                getIn(touched, 'subMeasurementType')
                  ? 'text-input has-error rtl'
                  : 'text-input required rtl'
              }
              clearable={true}
            />
            <ErrorMessage component={ErrorPopUp} name="subMeasurementType" />
          </div>

          <div className="col-md-3 col-sm-4">
            <label>ضریب تبدیل</label>
            <NumberFormat
              isNumericString
              allowNegative={false}
              defaultValue={values.conversionUnit}
              value={values.conversionUnit}
              name="conversionUnit"
              onChange={e => {
                setFieldValue('conversionUnit', e.target.value)
              }}
              onBlur={handleBlur}
              className={
                getIn(touched, 'conversionUnit')
                  ? getIn(errors, 'conversionUnit')
                    ? 'text-input has-error'
                    : 'text-input'
                  : 'text-input has-error'
              }
            />
            <ErrorMessage component={ErrorPopUp} name="conversionUnit" />
          </div>

          {categoryType === 1 &&
          values.subMeasurementType !== undefined &&
          (values.categoryId === 11 || values.categoryId === 12) ? (
            <div className="col-md-3 col-sm-12">
              <label>
                تعداد تایل در هر{' '}
                {values.subMeasurementType !== undefined &&
                measurementTypes.filter(
                  el => el.value === values.subMeasurementType
                )[0]
                  ? '(' +
                    measurementTypes.filter(
                      el => el.value === values.subMeasurementType
                    )[0].label +
                    ')'
                  : '(واحد)'}
              </label>
              <NumberFormat
                isNumericString
                allowNegative={false}
                defaultValue={values.numberOfParts}
                value={values.numberOfParts}
                name="conversionUnit"
                onChange={e => {
                  setFieldValue('numberOfParts', e.target.value)
                }}
                onBlur={handleBlur}
                className={
                  getIn(touched, 'numberOfParts')
                    ? getIn(errors, 'numberOfParts')
                      ? 'text-input has-error'
                      : 'text-input'
                    : 'text-input has-error'
                }
              />
              <ErrorMessage component={ErrorPopUp} name="numberOfParts" />
            </div>
          ) : (
            ''
          )}

          {categoryType === 2 &&
          (values.categoryId == 'd2e9c8ca-58e6-4c1f-b230-2a15a9a8bc39' ||
            values.categoryId == '898bbcaa-daa6-4b04-b1f9-5e4172016efd') ? (
            <div className="col-md-12">
              <fieldset className="fieldset">
                <legend>کالاهای مرتبط</legend>
                <table
                  className="table validator-table table-bordered"
                  style={{ marginBottom: 5 }}>
                  <thead>
                    <tr>
                      <th className="text-center" style={{ width: '10%' }}>
                        ردیف
                      </th>
                      <th className="text-center" style={{ width: '20%' }}>
                        نام واحد
                      </th>
                      <th className="text-center" style={{ width: '35%' }}>
                        محصول ورودی مرتبط
                      </th>
                      <th className="text-center" style={{ width: '35%' }}>
                        محصول خروجی مرتبط
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>واحد پرس</td>
                      <td />
                      <td>
                        <div className="col-md-12 col-sm-12 text-right">
                          <label>ورق پرس شده</label>
                          <AsyncProductSelect
                            brandId={values.brandId}
                            // categoryType={values.relatedProducts.filter(el => el.unitType === 4 && el.relatedProductType === 1)[0].categoryType}
                            categoryId={
                              initialRelatedProducts.filter(
                                el => el.index === 1
                              )[0].relatedProduct.category.id
                            }
                            defaultValue={
                              values.relatedProducts &&
                              values.relatedProducts.filter(
                                el => el.index === 1
                              )[0] &&
                              values.relatedProducts.filter(
                                el => el.index === 1
                              )[0].relatedProductId
                            }
                            onChange={val => {
                              let relatedProducts = values.relatedProducts
                              let rp = values.relatedProducts.filter(
                                el => el.index === 1
                              )[0]
                              if (rp) {
                                rp['relatedProductId'] = val.value
                              } else {
                                let new_rp = {}
                                new_rp['index'] = 1
                                new_rp['relatedProductId'] = val.value
                                relatedProducts.push(new_rp)
                              }
                              setFieldValue('relatedProducts', relatedProducts)
                            }}
                            className={
                              getIn(touched, 'productId')
                                ? getIn(errors, 'productId')
                                  ? 'semantic-select-box has-error'
                                  : 'semantic-select-box'
                                : 'semantic-select-box has-error'
                            }
                          />
                          <ErrorMessage
                            component={ErrorPopUp}
                            name={`relatedProducts[1].relatedProductId`}
                            style={{ top: 12 }}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>واحد برش</td>
                      <td />
                      <td>
                        <div className="col-md-12 col-sm-12 text-right">
                          <label>تایل برش داده شده</label>
                          <AsyncProductSelect
                            brandId={values.brandId}
                            categoryType={
                              initialRelatedProducts.filter(
                                el => el.index === 2
                              )[0].relatedProduct.category.categoryType
                            }
                            categoryId={
                              initialRelatedProducts.filter(
                                el => el.index === 2
                              )[0].relatedProduct.category.id
                            }
                            defaultValue={
                              values.relatedProducts &&
                              values.relatedProducts.filter(
                                el => el.index === 2
                              )[0] &&
                              values.relatedProducts.filter(
                                el => el.index === 2
                              )[0].relatedProductId
                            }
                            onChange={val => {
                              let relatedProducts = values.relatedProducts
                              let rp = values.relatedProducts.filter(
                                el => el.index === 2
                              )[0]
                              if (rp) {
                                rp['relatedProductId'] = val.value
                              } else {
                                let new_rp = {}
                                new_rp['index'] = 2
                                new_rp['relatedProductId'] = val.value
                                relatedProducts.push(new_rp)
                              }
                              setFieldValue('relatedProducts', relatedProducts)
                            }}
                            className={
                              getIn(touched, 'productId')
                                ? getIn(errors, 'productId')
                                  ? 'semantic-select-box has-error'
                                  : 'semantic-select-box'
                                : 'semantic-select-box has-error'
                            }
                          />
                          <ErrorMessage
                            component={ErrorPopUp}
                            name={`relatedProducts[2].relatedProductId`}
                            style={{ top: 12 }}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>واحد کلیک و بسته بندی</td>
                      <td>
                        <div className="col-md-12 col-sm-12 text-right">
                          <label>کارتن بسته بندی</label>
                          <AsyncProductSelect
                            brandId={values.brandId}
                            // categoryType={values.relatedProducts.filter(el => el.unitType === 7 && el.relatedProductType === 0)[0].categoryType}
                            categoryId={
                              initialRelatedProducts.filter(
                                el => el.index === 3
                              )[0].relatedProduct.category.id
                            }
                            defaultValue={
                              values.relatedProducts &&
                              values.relatedProducts.filter(
                                el => el.index === 3
                              )[0] &&
                              values.relatedProducts.filter(
                                el => el.index === 3
                              )[0].relatedProductId
                            }
                            onChange={val => {
                              let relatedProducts = values.relatedProducts
                              let rp = values.relatedProducts.filter(
                                el => el.index === 3
                              )[0]
                              if (rp) {
                                rp['relatedProductId'] = val.value
                              } else {
                                let new_rp = {}
                                new_rp['index'] = 3
                                new_rp['relatedProductId'] = val.value
                                relatedProducts.push(new_rp)
                              }

                              setFieldValue('relatedProducts', relatedProducts)
                            }}
                            className={
                              getIn(touched, 'productId')
                                ? getIn(errors, 'productId')
                                  ? 'semantic-select-box has-error'
                                  : 'semantic-select-box'
                                : 'semantic-select-box has-error'
                            }
                          />
                          <ErrorMessage
                            component={ErrorPopUp}
                            name={`relatedProducts[3].relatedProductId`}
                            style={{ top: 12 }}
                          />
                        </div>
                        <div className="col-md-12 col-sm-12 text-right">
                          <label>کارتن بسته بندی محصول درجه 2</label>
                          <AsyncProductSelect
                            brandId={74}
                            categoryType={
                              initialRelatedProducts.filter(
                                el => el.index === 4
                              )[0].categoryType
                            }
                            categoryId={12}
                            defaultValue={
                              values.relatedProducts &&
                              values.relatedProducts.filter(
                                el => el.index === 4
                              )[0] &&
                              values.relatedProducts.filter(
                                el => el.index === 4
                              )[0].relatedProductId
                            }
                            onChange={val => {
                              let relatedProducts = values.relatedProducts
                              let rp = values.relatedProducts.filter(
                                el => el.index === 4
                              )[0]
                              if (rp) {
                                rp['relatedProductId'] = val.value
                              } else {
                                let new_rp = {}
                                new_rp['index'] = 4
                                new_rp['relatedProductId'] = val.value
                                relatedProducts.push(new_rp)
                              }
                              setFieldValue('relatedProducts', relatedProducts)
                            }}
                            className={
                              getIn(touched, 'productId')
                                ? getIn(errors, 'productId')
                                  ? 'semantic-select-box has-error'
                                  : 'semantic-select-box'
                                : 'semantic-select-box has-error'
                            }
                          />
                          <ErrorMessage
                            component={ErrorPopUp}
                            name={`relatedProducts[4].relatedProductId`}
                            style={{ top: 12 }}
                          />
                        </div>
                      </td>
                      <td>
                        {!isGradeTwo ? (
                          <div className="col-md-12 col-sm-12 text-right">
                            <label>محصول درجه 2</label>
                            <AsyncProductSelect
                              brandId={values.brandId}
                              categoryType={2}
                              withCategory
                              // clearable
                              // categoryId={values.relatedProducts.filter(el => el.index === 4)[0].categoryId}
                              defaultValue={
                                values.relatedProducts &&
                                values.relatedProducts.filter(
                                  el => el.index === 0
                                )[0] &&
                                values.relatedProducts.filter(
                                  el => el.index === 0
                                )[0].relatedProductId
                              }
                              onChange={val => {
                                let relatedProducts = values.relatedProducts
                                let rp = values.relatedProducts.filter(
                                  el => el.index === 0
                                )[0]
                                if (val) {
                                  if (rp) {
                                    rp['relatedProductId'] = val.value
                                  } else {
                                    let new_rp = {}
                                    new_rp['index'] = 0
                                    new_rp['relatedProductId'] = val.value
                                    relatedProducts.push(new_rp)
                                  }
                                } else {
                                  if (rp) {
                                    rp['relatedProductId'] = undefined
                                  } else {
                                    let new_rp = {}
                                    new_rp['index'] = 0
                                    new_rp['relatedProductId'] = undefined
                                    relatedProducts.push(new_rp)
                                  }
                                }

                                setFieldValue(
                                  'relatedProducts',
                                  relatedProducts
                                )
                              }}
                              className={
                                getIn(touched, 'productId')
                                  ? getIn(errors, 'productId')
                                    ? 'semantic-select-box has-error'
                                    : 'semantic-select-box'
                                  : 'semantic-select-box has-error'
                              }
                            />
                            <ErrorMessage
                              component={ErrorPopUp}
                              name={`relatedProducts[0].relatedProductId`}
                              style={{ top: 12 }}
                            />
                          </div>
                        ) : (
                          ''
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </fieldset>
              {/* <ErrorMessage component={ErrorPopUp} name="relatedProducts" /> */}
              {/* <div className="ltr">
                {JSON.stringify(values.relatedProducts)}
                {values.relatedProducts.filter(el => el.unitType === 4 && el.relatedProductType === 1)[0].relatedProductId}
              </div> */}
            </div>
          ) : (
            ''
          )}

          <div className="col-md-12">
            <label>توضیحات</label>
            <Field
              name="description"
              rows="10"
              render={({ field }) => (
                <textarea
                  {...field}
                  value={values.description}
                  className={
                    getIn(touched, 'description')
                      ? getIn(errors, 'description')
                        ? 'textarea rtl'
                        : 'textarea rtl'
                      : 'textarea rtl'
                  }
                />
              )}
            />
            <ErrorMessage component={ErrorPopUp} name="description" />
          </div>
        </div>
      </div>
    </div>
  </div>
)
